import {
	Dispatch,
} from 'redux';
// Import services
import {
	StringService,
} from '@app/services';
// Import action type enumeration.
import ActionType from '@app/redux/actions/types';
import {
	NotificationType,
} from '@app/enumerations';
// Import api models.
import {
	ProducerInfo,
} from '@app/models/api';
// Import controller factory.
import ControllerFactoryProvider from '@app/controllers/factory';
// Import action methods.
import {
	addNotification,
	endProcessing,
	startProcessing,
} from '@app/redux/actions/methods';
// Import actions.
import {
	PolicyAction,
} from '@app/redux/actions';
// import action parameters.
import {
	PolicyParameters
} from './ActionParametersBarrel';
// import action parameters.
import {
	OverlayTargetParameters,
} from './ActionParametersBarrel';


// Load Producer Action.

interface LoadProducerAction extends PolicyAction {
	producerInfo: ProducerInfo;
}

type LoadProducerParameters = PolicyParameters & OverlayTargetParameters;

const loadProducerAction: (producerInfo: ProducerInfo, params: PolicyParameters) =>
	LoadProducerAction = (producerInfo: ProducerInfo, params: PolicyParameters) => ({
		...params,
		producerInfo: producerInfo,
		type: ActionType.LOAD_PRODUCER,
	});

const loadProducer = (params: LoadProducerParameters) =>
	async (dispatch: Dispatch): Promise<ProducerInfo> => {
		// Generate message id.
		const messageId: string = `${StringService.getInstance().hashObject(params)}-loadProducer`;
		try {
			// Start processing.
			await startProcessing({
				message: 'Loading producer information...',
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);
			// Call api to load producer info.
			let producerInfo: ProducerInfo = await ControllerFactoryProvider.getControllerFactory().getPolicyController().getPolicyProducerInfo(params.policyId);
			// Load producer info to redux.
			dispatch<LoadProducerAction>(loadProducerAction(producerInfo, params));
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);

			return producerInfo;
		}
		catch (error: any) {
			// Add error notification.
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);
			// Throw error;
			throw error;
		}
	};


// Change Producer Agent Action.

interface ChangeProducerAgentParameters extends PolicyParameters, OverlayTargetParameters{
	producerAgentId: number;
}

const changeProducerAgent = ({ producerAgentId, overlayTarget, ...params }: ChangeProducerAgentParameters) =>
	async (dispatch: Dispatch): Promise<ProducerInfo> => {
		// Generate message id.
		const messageId: string = `${StringService.getInstance().hashObject(params)}-changeProducerAgent`;
		try {
			// Start processing.
			await startProcessing({
				message: 'Updating producer information...',
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);
			// Call api to change the producer agent.
			await ControllerFactoryProvider.getControllerFactory().getPolicyController().changePolicyProducerAgent(params.policyId, producerAgentId);
			// Call api to load producer info after updating it.
			let producerInfo: ProducerInfo = await ControllerFactoryProvider.getControllerFactory().getPolicyController().getPolicyProducerInfo(params.policyId);
			// Load producer info to redux.
			dispatch<LoadProducerAction>(loadProducerAction(producerInfo, params));
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);

			return producerInfo;
		}
		catch (error: any) {
			// Add error notification.
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);
			// Throw error;
			throw error;
		}
	};


// Change Producer Agency Action.

interface ChangeProducerAgencyParameters extends PolicyParameters, OverlayTargetParameters {
	producerAgencyId: number;
}

const changeProducerAgency = ({ producerAgencyId, overlayTarget, ...params }: ChangeProducerAgencyParameters) =>
	async (dispatch: Dispatch): Promise<ProducerInfo> => {
		// Generate message id.
		const messageId: string = `${StringService.getInstance().hashObject(params)}-changeProducerAgency`;
		try {
			// Start processing.
			await startProcessing({
				message: 'Updating producer information...',
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);
			// Call api to change the producer agency
			await ControllerFactoryProvider.getControllerFactory().getPolicyController().changePolicyProducerAgency(params.policyId, producerAgencyId);
			// Call api to load producer info after updating it.
			let producerInfo: ProducerInfo = await ControllerFactoryProvider.getControllerFactory().getPolicyController().getPolicyProducerInfo(params.policyId);
			// Load producer info to redux.
			dispatch<LoadProducerAction>(loadProducerAction(producerInfo, params));
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);

			return producerInfo;
		}
		catch (error: any) {
			// Add error notification.
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: overlayTarget,
			})(dispatch);
			// Throw error;
			throw error;
		}
	};

// Export actions.
export {
	LoadProducerAction
};

// Export action methods.
export {
	loadProducer,
	changeProducerAgent,
	changeProducerAgency,
};

// Export action parameters.
export {
	LoadProducerParameters,
	ChangeProducerAgentParameters,
	ChangeProducerAgencyParameters,
};

// Export action factories.
export {
	loadProducerAction,
};